import {createRouter, createWebHashHistory,} from 'vue-router'

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('@/views/Home.vue'),
        },
        {
            path: '/impressum',
            name: 'Impressum',
            component: () => import('@/views/Impressum.vue'),
        },
    ],
})

export default router
